// TODO: rename StudyOverview
import React, { useState, useEffect } from "react"
import { useParams, useNavigate, useLocation, Link } from "react-router-dom"

// components
import Team from "components/MyTeamPanel/MyTeamPanel"
import TimelineFeed from "components/TimelineFeed/TimelineFeed"
import GridTypeA from "components/grids/GridTypeA/GridTypeA"
import { Panel } from "components-design-system"
import { Flex } from "antd"

// apis
import { useGetStudy } from "api/hooks/studies/useStudiesApi"
import { useGetStudyActivities } from "api/hooks/studies/useActivitiesApi"
import { useGetStudyTeam, usePostStudyTeam } from "api/hooks/studies/studyTeamsApi"
import { useGetRoles } from "api/hooks/users/userRolesApi"
import { useGetStudyFeed } from "api/hooks/studies/useTimelineFeedApi"

// utils
import useActivitiesColDefs from "../../hooks/useActivitiesColDefs"

const Overview = () => {
  const { studyId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const { data: studyData } = useGetStudy(studyId)
  const { data: activities = [] } = useGetStudyActivities(studyId)
  const { data: team } = useGetStudyTeam(studyId)
  const { data: userRoles } = useGetRoles()
  const postStudyTeam = usePostStudyTeam(studyId)
  const [timelineFeedParams, setTimelineFeedParams] = useState({
    labels: [],
    showActivity: false,
  })
  const { data: studyFeed, refetch: refetchFeed } = useGetStudyFeed(studyId, timelineFeedParams)
  const gridRef = React.useRef()
  const { columnDefs } = useActivitiesColDefs(studyId, true)

  useEffect(() => {
    refetchFeed()
  }, [timelineFeedParams])

  const doesExternalFilterPass = React.useCallback(
    (node) => {
      if (node.data.progress_status === "ongoing") {
        return true
      }
      return false
    },
    [activities]
  )

  const isExternalFilterPresent = React.useCallback(() => {
    return true
  }, [])

  return (
    <Flex
      vertical
      gap={24}
    >
      <Panel
        title="ONGOING ACTIVITIES"
        iconClassName="fa-light fa-play"
        className="study-overview-panel"
        subtitle={
          <Flex>
            <p className="study-overview-subtitle">To see all activities go to the&nbsp;</p>
            <a
              className="study-overview-subtitle-action prime-link"
              onClick={() => navigate(location.pathname.replace("overview", "activities"))}
            >
              Activities Tab
            </a>
          </Flex>
        }
      >
        <GridTypeA
          gridRef={gridRef}
          columnDefs={columnDefs}
          domLayout="autoHeight"
          rowData={activities}
          className="study-overview-grid"
          pagination={true}
          paginationPageSize={10}
          paginationPageSizeSelector={[10, 20, 50, 100]}
          isExternalFilterPresent={isExternalFilterPresent}
          doesExternalFilterPass={doesExternalFilterPass}
        />
      </Panel>
      <Flex gap={24}>
        <TimelineFeed
          type="study"
          timeline={studyFeed?.timeline}
          refetchTimeline={refetchFeed}
          modalMsg={studyData?.study_id}
          timelineFeedParams={timelineFeedParams}
          setTimelineFeedParams={setTimelineFeedParams}
          style={{ flex: 2 }}
        />
        <Team
          type={"study"}
          team={team}
          roles={userRoles}
          postTeam={postStudyTeam}
          style={{ flex: 1 }}
        />
      </Flex>
    </Flex>
  )
}

export default Overview
